import { getRangeMinMax } from '../reducers/utils/range/get-range-min-max';
import { type GridPosition, type SelectionState } from '../state/types';

/**
 * Returns true if the given cell is within the current selection.
 * Considers mode: cell (bounding box), row (row span), column (col span).
 */
export function isCellSelected(state: SelectionState, cell: GridPosition): boolean {
  if (state.mode === 'idle' || state.selections.length === 0) {
    return false;
  }

  // Early optimization: in cell mode, there's only a single range (selections[0])
  if (state.mode === 'cell') {
    const range = state.selections[0];
    const rowRange = getRangeMinMax(range, 'row');
    const colRange = getRangeMinMax(range, 'col');
    return (
      cell.row.index >= rowRange.min &&
      cell.row.index <= rowRange.max &&
      cell.col.index >= colRange.min &&
      cell.col.index <= colRange.max
    );
  }

  if (state.mode === 'row') {
    for (const range of state.selections) {
      const { min, max } = getRangeMinMax(range, 'row');
      if (cell.row.index >= min && cell.row.index <= max) {
        return true;
      }
    }
    return false;
  }

  // Column mode
  for (const range of state.selections) {
    const { min, max } = getRangeMinMax(range, 'col');
    if (cell.col.index >= min && cell.col.index <= max) {
      return true;
    }
  }

  return false;
}
